import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeContextProvider } from './contexts/ThemeContext';
import ThemeProvider from './theme/ThemeProvider';

const container = document.getElementById("root");

if (!container) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeContextProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </ThemeContextProvider>
    </Provider>
  </React.StrictMode>
);
